module.exports = __webpack_public_path__ + "img/background.4152c43b.png";